import React, { useEffect, useState } from 'react';
import { useStyletron } from 'baseui';
import { SIZE, StyledDivider } from 'baseui/divider';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { getProjectAccounting } from '@gtintel/platform-api';
import ConvertedFeeStatistic, { Statistic } from './ConvertedFeeStatistic';
const AccountingDetail = ({
  projectId
}) => {
  const [css] = useStyletron();
  const [accounting, setAccounting] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getProjectAccounting(projectId).then(accounting => setAccounting(accounting)).catch(() => {
      setAccounting({
        revenue: 0,
        final_revenue: 0,
        revenue_conversion_date: new Date(),
        cost: 0,
        final_cost: 0,
        cost_conversion_date: new Date(),
        partner_fee: 0,
        partner_currency: 'USD',
        partner_fee_conversion_date: new Date(),
        gross_profit: 0,
        gross_margin: 0,
        net_profit: 0,
        net_margin: 0,
        modified_date: new Date()
      });
    }).finally(() => setLoading(false));
  }, [projectId]);
  return <>
      <FlexGrid flexGridColumnCount={2} flexGridColumnGap="scale800">
        <FlexGridItem>
          <ConvertedFeeStatistic title="Revenue (including Adjustments and Subprojects)" value={accounting?.final_revenue} prefix="£" loading={loading} conversionDate={new Date(accounting?.revenue_conversion_date)} />
        </FlexGridItem>

        <FlexGridItem>
          <ConvertedFeeStatistic title="COGS (Adjustments + QA + NP + Subprojects)" value={accounting?.final_cost} prefix="£" loading={loading} conversionDate={new Date(accounting?.cost_conversion_date)} />
        </FlexGridItem>
      </FlexGrid>
      <StyledDivider $size={SIZE.cell} />
      <FlexGrid flexGridColumnCount={2} flexGridColumnGap="scale800">
        <FlexGridItem>
          <Statistic title="Net Profit" value={accounting?.net_profit} prefix="£" loading={loading} />
        </FlexGridItem>

        <FlexGridItem>
          <Statistic title="Net Margin" value={accounting?.net_margin * 100} suffix="%" loading={loading} />
        </FlexGridItem>
      </FlexGrid>
      <p className={css({
      fontSize: '0.75rem',
      color: '#666666',
      paddingTop: '2.5rem'
    })}>
        These are the financials for the parent project where appropriate. Last
        updated{' '}
        {new Date(accounting?.modified_date).toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      })}
      </p>
    </>;
};
export default AccountingDetail;